// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74fd9570","239":"7637df99","455":"f93b5364"}[chunkId] + ".chunk.js";
};